const envConstants = {
    API_PRICE_BASE_URL: process.env.REACT_APP_PRICE_BASE_API_URL || 'http://localhost:3002',
    MANAGER_API_URL: process.env.REACT_APP_MANAGER_API_URL || 'http://localhost:3003',
};

export { envConstants };
